<template>
  <v-card class="mx-auto br-3">
    <v-card-title class="pb-0">
      <v-icon
        large
        left
      >
        mdi-fire
      </v-icon>
      <span class="subtitle-1">{{ $t('boiler') }}</span>
    </v-card-title>

    <v-card-text class="pb-0">
      <div class="d-flex flex-row align-center">
        <div class="w-mode text-center">
          <v-menu bottom >
            <template v-slot:activator="{ on }">
              <v-btn
                :color="(boilerMode == 2) ? 'primary' : ''"
                rounded
                large
                v-on="(permission == 0 || permission == 1) ? on : false"
                :loading="savingBoilerMode"
                :disabled="savingBoilerMode"
              >
                {{ boilerModes[boilerMode] }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="setBoilerMode(0)" key="0" :class="{ act: boilerMode == 0 }">
                <v-list-item-title class="text-center">{{ boilerModes[0] }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setBoilerMode(2)" key="2" :class="{ act: boilerMode == 2 }">
                <v-list-item-title class="text-center">{{ boilerModes[2] }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="d-flex flex-column w-set pa-0 text-center font-weight-medium subtitle-1">
          <div class="accent--text">{{ parseInt(this.params.boilerTempSet) }} &deg;C</div>
          <div class="secondary--text">{{ parseInt(this.params.boilerTempReduced) }} &deg;C</div>
        </div>
        <v-card flat ripple :to="(permission == 0 || permission == 1) ? '/dashboard/boiler-temp/'+controllerId : '/dashboard/'+controllerId" class="w-read">
          <v-gauge :value="boilerTemp" :minValue="boilerTempMin" :maxValue="boilerTempMax" :decimalPlace="0" :options="gOptions" height="250" />
          <div class="unit">&deg;C</div>
        </v-card>
      </div>
    </v-card-text>

    <v-card-actions class="pt-0">
      <v-btn v-if="boilerCalendar !== undefined"
      icon large 
      :color="(boilerCalendar == 1) ? 'primary' : 'info'" 
      :loading="savingBoilerCalendar"
      :disabled="savingBoilerCalendar"
      @click="calendarSheet = (permission == 0 || permission == 1) ? !calendarSheet : calendarSheet" class="key-btn">
        <v-icon>mdi-calendar-month</v-icon>
      </v-btn>
      <v-btn v-if="boilerWeatherMode !== undefined"
      icon large 
      :color="(boilerWeatherMode == 1) ? 'primary' : 'info'" 
      :loading="savingBoilerWeatherMode"
      :disabled="savingBoilerWeatherMode"
      @click="weatherSheet = (permission == 0 || permission == 1) ? !weatherSheet : weatherSheet" class="key-btn">
        <v-icon>mdi-weather-snowy</v-icon>
      </v-btn>
      <v-btn v-if="pumpCO !== undefined"
      icon large 
      :color="(params.pumpCO == '1') ? 'primary' : 'info'" 
      @click="pumpCoSheet = (permission == 0 || permission == 1) ? !pumpCoSheet : pumpCoSheet" class="key-btn">
        <v-icon>mdi-atom-variant</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn icon large @click="more = !more">
        <v-icon>{{ more ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="more">
        <v-row class="py-3">
          <v-col cols="6" v-if="(boilerPower !== undefined)" class="pb-0">
            <v-card class="mx-auto pa-0" flat>
              <v-card-title class="body-2 text-center pt-0"><div class="w-100 font-weight-light">{{ $t('boilerPower') }}</div></v-card-title>
              <v-card-text class="title font-weight-bold px-0">
                <div class="text-center">
                  <v-progress-circular
                    :rotate="90"
                    :size="100"
                    :width="13"
                    :value="(more) ? boilerPower : 0"
                    color="success"
                  >
                    {{ boilerPower }}%
                  </v-progress-circular>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" v-if="(blowPower !== undefined)" class="pb-0">
            <v-card class="mx-auto" flat>
              <v-card-title class="body-2 text-center pt-0"><div class="w-100 font-weight-light">{{ $t('blowPower') }}</div></v-card-title>
              <v-card-text class="title font-weight-bold px-0">
                <div class="text-center">
                  <v-progress-circular
                    :rotate="90"
                    :size="100"
                    :width="13"
                    :value="(more) ? blowPower : 0"
                    color="success"
                  >
                    {{ blowPower }}%
                  </v-progress-circular>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" v-if="(fuel !== undefined)" class="pb-0">
            <v-card class="mx-auto" flat>
              <v-card-title class="body-2 text-center pt-0"><div class="w-100 font-weight-light">{{ $t('fuel') }}</div></v-card-title>
              <v-card-text class="title font-weight-bold px-0">
                <div class="text-center">
                  <v-progress-circular
                    :rotate="90"
                    :size="100"
                    :width="13"
                    :value="(more) ? fuel : 0"
                    color="success"
                  >
                    {{ fuel }}%
                  </v-progress-circular>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <v-bottom-sheet v-model="calendarSheet">
      <v-sheet>
        <div class="px-4 pt-6 pb-3">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-1">{{ $t('tryb-kal') }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-btn icon @click="calendarSheet = !calendarSheet">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list flat>
            <v-list-item ripple class="br-3 selected">
              <v-list-item-icon>
                <v-icon>mdi-calendar-month</v-icon>
              </v-list-item-icon>
              <v-list-item-content @click="onChangeBoilerCalendar">
                <v-list-item-title class="title">{{ $t('wlacz') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch :input-value="boilerCalendarSetting" color="primary" @change="onChangeBoilerCalendar"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item :to="'/dashboard/boiler-calendar/'+controllerId" class="br-3">
              <v-list-item-icon>
                <v-icon>mdi-settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="title">{{ $t('Ustawienia') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="weatherSheet">
      <v-sheet>
        <div class="px-4 pt-6 pb-3">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-1">{{ $t('tryb-pog') }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-btn icon @click="weatherSheet = !weatherSheet">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list flat>
            <v-list-item ripple class="br-3 selected">
              <v-list-item-icon>
                <v-icon>mdi-weather-snowy</v-icon>
              </v-list-item-icon>
              <v-list-item-content @click="onChangeBoilerWeatherMode">
                <v-list-item-title class="title">{{ $t('wlacz') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch :input-value="boilerWeatherModeSetting" color="primary" @change="onChangeBoilerWeatherMode"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item :to="'/dashboard/weather-mode/' + controllerId" class="br-3">
              <v-list-item-icon>
                <v-icon>mdi-settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="title">{{ $t('Ustawienia') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="pumpCoSheet">
      <v-sheet>
        <div class="px-3 py-6">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-1">{{ $t('Pompa CO') }} {{ (this.params.pumpCO == '1') ? $t('dziala') : $t('nie dziala') }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-btn icon @click="pumpCoSheet = !pumpCoSheet">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </v-card>
</template>

<script>
import VGauge from "vgauge";
export default {
  components: {
    VGauge
  },
  data: () => ({
    boilerModes: ['STOP','X','AUTO'],
    savingBoilerMode: false,
    more: false,
    value: 35,
    calendarSheet: false,
    boilerCalendarSetting: false,
    savingBoilerCalendar: false,
    weatherSheet: false,
    boilerWeatherModeSetting: false,
    savingBoilerWeatherMode: false,
    pumpCoSheet: false
  }),
  computed: {
    gOptions() {
      return {
        angle: -0.18,
        lineWidth: 0.18,
        pointer: {
          length: 0,
          strokeWidth: 0
        },
        colorStart: (this.dark) ? '#EF5350' : '#EF3024',
        strokeColor: (this.dark) ? 'rgba(0,0,0,0.3)' : '#E0E0E0'
      }
    },
    params () {
      return this.$store.state[this.moduleName].params
    },
    boilerTemp () {
      return parseInt(this.params.boilerTemp)
    },
    blowPower () {
      return parseInt(this.params.blowPower)
    },
    boilerPower () {
      return parseInt(this.params.boilerPower)
    },
    boilerCalendar () {
      return (this.params.boilerCalendar !== undefined) ? parseInt(this.params.boilerCalendar) : undefined
    },
    boilerWeatherMode () {
      return (this.params.boilerWeatherMode !== undefined) ? parseInt(this.params.boilerWeatherMode) : undefined
    },
    pumpCO () {
      return (this.params.pumpCO !== undefined) ? parseInt(this.params.pumpCO) : undefined
    },
    fuel () {
      return (this.params.fuel !== undefined) ? parseInt(this.params.fuel) : undefined
    },
    boilerMode () {
      return parseInt(this.params.boilerMode)
    },
    boilerTempMin() {
      return this.$store.state[this.moduleName].boilerTempMin
    },
    boilerTempMax() {
      return this.$store.state[this.moduleName].boilerTempMax
    },
    dark() {
      return this.$store.state.user.dark;
    }
  },
  created () {
    this.boilerCalendarSetting = (this.boilerCalendar == 1) ? true : false;
    this.boilerWeatherModeSetting = (this.boilerWeatherMode == 1) ? true : false;
  },
  props: ['moduleName','controllerId','permission','loading'],
  methods: {
    setBoilerMode(mode) {
      this.savingBoilerMode = true;
      this.$store.dispatch(`${this.moduleName}/setBoilerMode`, mode)
      .then(res => {
        this.savingBoilerMode = false;
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
        } 
      });
    },
    onChangeBoilerCalendar() {
      this.boilerCalendarSetting = !this.boilerCalendarSetting;
      this.setBoilerCalendar((this.boilerCalendarSetting) ? 1 : 0);
    },
    setBoilerCalendar(mode) {
      this.savingBoilerCalendar = true;
      setTimeout(() => { this.calendarSheet = false; }, 300);
      this.$store.dispatch(`${this.moduleName}/setBoilerCalendar`, mode)
      .then(res => {
        this.savingBoilerCalendar = false;
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
          this.boilerCalendarSetting = (this.boilerCalendar == 1) ? true : false;
        }
      });
    },
    onChangeBoilerWeatherMode() {
      this.boilerWeatherModeSetting = !this.boilerWeatherModeSetting;
      this.setBoilerWeatherMode((this.boilerWeatherModeSetting) ? 1 : 0);
    },
    setBoilerWeatherMode(mode) {
      this.savingBoilerWeatherMode = true;
      setTimeout(() => { this.weatherSheet = false; }, 300);
      this.$store.dispatch(`${this.moduleName}/setBoilerWeatherMode`, mode)
      .then(res => {
        this.savingBoilerWeatherMode = false;
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
          this.boilerWeatherModeSetting = (this.boilerWeatherMode == 1) ? true : false;
        } else {
          setTimeout(() => { 
            this.$store.dispatch(`${this.moduleName}/syncController`, true); //odswiez zeby pokazac pompy
          }, 5000);
        }
      });
    },
    gotoDash (id) {
      this.$router.push({ path: '/dashboard/'+id });
    }
  }
  
}
//http://bernii.github.io/gauge.js/#!
//https://github.com/amroessam/vgauge
//https://hellocomet.github.io/vue-svg-gauge/
//https://canvas-gauges.com/
//https://www.behance.net/gallery/72345877/Alfa-Bank-Redesign
//https://www.behance.net/gallery/71918463/Stronghold-Smart-Home-App
//https://medium.com/hypefactors/add-i18n-and-manage-translations-of-a-vue-js-powered-website-73b4511ca69c lang route
</script>

<style>
.w-mode {
  width: 35%;
}
.w-set{
  width: 22%;
}
.w-set .v-btn {
  font-size: 1rem;
}
.w-read {
  width: 43%;
  position: relative;
}

.w-read canvas {
  width: 100% !important;
  height: auto !important;
}
.w-read .gauge-title {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2.25rem;
  font-weight: 500;
}
.unit {
  position: absolute;
  left: 0; 
  right: 0; 
  top: 55%;
  margin-top: 16px;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
}
</style>